export const DIMENSIONAL_VALUES_SHOWN = ["5", "10", "20"];
